"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var getClassName = function getClassName(inline, styled, className, use) {
  return (0, _classNames.default)('uiList', {
    'private-list--inline': inline,
    'private-list--inline-divided': use === 'inline-divided',
    'private-list--unstyled': !styled
  }, className);
};

var renderItems = function renderItems(children, childClassName, firstChildClassName, lastChildClassName) {
  return _react.Children.map(children, function (child, i) {
    if (child == null) {
      return null;
    }

    var computedChildClassName;

    if (i === 0 && firstChildClassName != null) {
      computedChildClassName = firstChildClassName;
    } else if (!children.hasOwnProperty(i + 1) && lastChildClassName != null) {
      computedChildClassName = lastChildClassName;
    } else {
      computedChildClassName = childClassName;
    }

    var className = (0, _classNames.default)('uiListItem', 'private-list__item', computedChildClassName);
    return _react.default.createElement("li", {
      className: className
    }, child);
  });
};

var renderOrdered = function renderOrdered(rest, computedClassName, renderedItems) {
  return _react.default.createElement("ol", (0, _extends2.default)({}, rest, {
    className: computedClassName
  }), renderedItems);
};

var renderUnordered = function renderUnordered(rest, computedClassName, renderedItems) {
  return _react.default.createElement("ul", (0, _extends2.default)({}, rest, {
    className: computedClassName
  }), renderedItems);
};

var _default = _react.default.createClass({
  displayName: "UIList",
  propTypes: {
    childClassName: _react.PropTypes.string,
    children: _react.PropTypes.node,
    firstChildClassName: _react.PropTypes.string,
    inline: _react.PropTypes.bool.isRequired,
    lastChildClassName: _react.PropTypes.string,
    ordered: _react.PropTypes.bool.isRequired,
    styled: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(['default', 'inline-divided'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      inline: false,
      ordered: false,
      styled: false,
      childClassName: '',
      use: 'default'
    };
  },
  render: function render() {
    var _this$props = this.props,
        ordered = _this$props.ordered,
        styled = _this$props.styled,
        inline = _this$props.inline,
        className = _this$props.className,
        children = _this$props.children,
        childClassName = _this$props.childClassName,
        firstChildClassName = _this$props.firstChildClassName,
        lastChildClassName = _this$props.lastChildClassName,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["ordered", "styled", "inline", "className", "children", "childClassName", "firstChildClassName", "lastChildClassName", "use"]);
    var computedClassName = getClassName(inline, styled, className, use);
    var renderedItems = renderItems(children, childClassName, firstChildClassName, lastChildClassName);

    if (use === 'inline-divided' && !inline) {
      _devLogger.default.warn({
        message: 'UIList: `inline` needs to be `true` when `use="inline-divided"` is set',
        key: 'UIList: use inline-divided requires inline'
      });
    }

    if (ordered) {
      return renderOrdered(rest, computedClassName, renderedItems);
    }

    return renderUnordered(rest, computedClassName, renderedItems);
  }
});

exports.default = _default;
module.exports = exports.default;